<template>
    <div class="document-signature__toggle overflow-hidden">
        <div class="float-left">
            <small>As a representative of this organization I am authorized to accept these terms and conditions</small>
        </div>
        <div class="float-right">
            <small>Accept </small><input type="checkbox" v-on:change="$emit('toggleDocument', document.id)" :checked="this.signed" data-dusk="signature-toggle"/>
        </div>
    </div>
</template>

<script>
import ToggleButton from 'vue-js-toggle-button';
Vue.use(ToggleButton);

export default {
    name: 'SignatureToggle',

    props: {
        signed: Boolean,
        document: Object
    }
};
</script>

<style scoped>
    .overflow-hidden {
        overflow: hidden;
    }
    .float-right {
        float: right;
    }
    .float-left {
        float: left;
    }
</style>
